import { render } from "./PedigreeHorse.vue?vue&type=template&id=a6ceb7d2"
import script from "./PedigreeHorse.vue?vue&type=script&lang=js"
export * from "./PedigreeHorse.vue?vue&type=script&lang=js"

import "./PedigreeHorse.vue?vue&type=style&index=0&id=a6ceb7d2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__